import { UseAndCareVideoModel } from '../../../interface/support-and-service';

export function UseAndCareVideoContainer(props: UseAndCareVideoModel) {
  const { Title, youtube_link } = props;

  return (
    <div className="p-4 border border-primaryGray flex flex-col justify-between">
      <p className="uppercase text-caption font-MuseoSans300">{Title}</p>
      <iframe
        allowFullScreen
        className="w-full h-80 py-4 lg:p-4"
        src={youtube_link}
      />
    </div>
  );
}

export default UseAndCareVideoContainer;
